import React, { useEffect, useRef } from 'react';
import styles from './OverlayAllItem.module.scss';
import { useDispatch, useSelector } from 'react-redux';
import { SET_KEYBOARD_POSITION } from '../../Store/Actions/ActionTypes';
import autocompleteKeyboardNavigation from '../../Utils/autocompleteKeyboardNavigation';
import { getUtdanningSiteBaseUrl } from '../../Utils/getUtdanningSiteBaseUrl';
import externalLink from '../../img/external_link.svg';

const OverlayAllItem = (props) => {
    const newFilterState = useSelector(state => state.newFilterReducer);
    const dispatch = useDispatch();
    const { title, type, programStatus, forsteSemester, sisteSemester, url, keybActive } = props;

    const isExternal = /karriereveiledning\.no\//.test(url);

    const clickHandler = (val) => {
        // Note 21042020-Autocomplete:
        // This was first implemented to use the value of the clicked element as search value.
        // It's changing now, to open the drupal entity directly.
        // Keep this part for future use.
        /*
        dispatch(handleSearchValueSubmit(val));
        dispatch(closeOverlay());
        */

        if (url.indexOf('https') === -1) {
            window.location.href = getUtdanningSiteBaseUrl() + url;
        }
        else {
            window.location.href = url;
        }
    };

    let myClass = styles.wrapper;
    if (keybActive) {
        myClass += ` ${styles.active}`;
    }

    const acSearchResultRaw = newFilterState.acSearchResult;
    const acSearchResult = acSearchResultRaw ? acSearchResultRaw['hydra:member'] : [];
    const position = newFilterState.acKeyboardPosition;
    const keyDown = (e) => {
        const newPosition = autocompleteKeyboardNavigation(position, e, acSearchResult);
        if (newPosition === null) {
            document.getElementById('search-input').focus();
        }
        if (position !== newPosition) {
            // Only dispatch the action if the position has changed.
            dispatch({ type: SET_KEYBOARD_POSITION, payload: newPosition });
        }
        if (e.keyCode === 13) { // Handle enter
            clickHandler(title);
        }
    };

    const divRef = useRef(null);
    useEffect(() => {
        if (keybActive) {
            divRef.current.focus();
        }
    }, [ keybActive ]);


    let semesterInfo = '';
    let expired = false;

    switch (programStatus) {
        case 'UTLØPT':
            semesterInfo = `(Utgikk ${sisteSemester.toLowerCase()})`;
            expired = true;
            break;
        /* @TODO Legg til status "UTGÅENDE" */
        case 'KOMMENDE':
            semesterInfo = `(Fra ${forsteSemester.toLowerCase()})`;
            break;
        case 'GYLDIG':
        case '':
            break;
        default:
            console.log(programStatus);
            break;
    }

    return (
        <div onKeyDown={keyDown} tabIndex="0" ref={divRef} className={myClass} onClick={() => clickHandler(title)}>
            <div>
                <div className={styles.title} style={expired ? { textDecoration: 'line-through' } : {}}>
                    {title}
                </div>
                {isExternal && <img className={styles.title_external} src={externalLink} />}
                <div>{semesterInfo}</div>
            </div>
            <div className={styles.type}>{type}</div>
        </div>
    );

};

export default OverlayAllItem;
